export interface EnvironmentConfigModel {
  production: boolean;
  viewerBaseUrl: string;
}
